module.exports = __webpack_public_path__ + "img/card_franchise3.03515e4c.svg";